var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"full-screen-btn",attrs:{"color":"rgba(15,15,15, 0.36)","fab":"","small":""},on:{"click":_vm.onToggleFullscreen}},[(!_vm.isFullScreen)?_c('v-icon',{attrs:{"color":"white","dark":""}},[_vm._v("mdi-fullscreen")]):_c('v-icon',{attrs:{"color":"white","dark":""}},[_vm._v("mdi-fullscreen-exit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }